import React from "react";

// Admin Imports
import MainDashboard from "views/admin/default";
import MyTrips from "views/admin/default/MisViajes";
import ProfileOverview from "views/admin/profile";
import Promociones from "views/admin/default/Promociones";
import Visualiza from "views/admin/default/Visualiza";


// Auth Imports
import SignIn from "views/auth/SignIn";
import SignUp from "views/auth/SignUp";

// Icon Imports
import {
  MdHome,
  MdLock,
  MdOutlineAirplaneTicket,
  MdDiscount,
  MdPerson,
} from "react-icons/md";

const routes = [
  {
    name: "Perfil",
    layout: "/admin",
    path: "default",
    icon: <MdPerson className="h-6 w-6" />,
    component: <MainDashboard />,
    show:true
  },
  {
    name: "Mis viajes",
    layout: "/admin",
    path: "misviajes",
    icon: <MdOutlineAirplaneTicket className="h-6 w-6" />,
    component: <MyTrips />,
    show:true
  },
  {
    name: "Promociones",
    layout: "/admin",
    path: "promociones",
    icon: <MdDiscount className="h-6 w-6" />,
    component: <Promociones />,
    show:true
  },
  {
    name: "Facturación",
    layout: "/admin",
    path: "invoice/:monto/:folio/:empresa",
    icon: <MdHome className="h-6 w-6" />,
    component: <ProfileOverview />
  },
  {
    name: "Visualiza",
    layout: "/admin",
    path: "trip/:ticket/:user_id",
    icon: <MdHome className="h-6 w-6" />,
    component: <Visualiza />
  },
  {
    name: "Sign In",
    layout: "/auth",
    path: "sign-in",
    icon: <MdLock className="h-6 w-6" />,
    component: <SignIn />,
  },
  {
    name: "Sign In Callback",
    layout: "/auth",
    path: "callback-sign-in",
    icon: <MdLock className="h-6 w-6" />,
    component: <SignIn />,
  },
  {
    name: "Sign Up",
    layout: "/auth",
    path: "sign-up",
    icon: <MdLock className="h-6 w-6" />,
    component: <SignUp />,
  },
];
export default routes;
